(() => {
  const main = document.querySelector('main[data-template="product"]');
  if (!main) return;
  document.body.classList.add('milipow-product-page');

  const staleNotification = document.querySelector('cart-notification');
  if (staleNotification) {
    staleNotification.remove();
  }

  let form = document.querySelector('product-form form[action*="/cart/add"]');
  if (!form) {
    form = Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find((candidate) =>
      candidate.querySelector('[type="submit"]')
    );
  }
  const submit = form?.querySelector('[type="submit"]');
  if (!form || !submit) return;

  const existing = document.querySelector('.milipow-sticky-buy');
  if (existing) return;

  const priceSource = document.querySelector('[id^="price-"]');
  const readPrice = () =>
    priceSource
      ?.querySelector('.price-item--sale, .price-item--regular, .price-item')
      ?.textContent?.trim() || '';
  const price = readPrice();
  const bar = document.createElement('div');
  bar.className = 'milipow-sticky-buy';
  bar.setAttribute('aria-label', 'Mobile purchase bar');
  bar.innerHTML = `
    <span class="milipow-sticky-buy__price">${price}</span>
    <button class="milipow-sticky-buy__button" type="button">Add to cart</button>
  `;

  bar.querySelector('button').addEventListener('click', () => {
    submit.click();
  });

  document.body.appendChild(bar);

  if (priceSource) {
    const priceTarget = bar.querySelector('.milipow-sticky-buy__price');
    new MutationObserver(() => {
      priceTarget.textContent = readPrice();
    }).observe(priceSource, { childList: true, subtree: true, characterData: true });
  }
})();
